// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"196faffc","513":"99ecb763","703":"1bb9563b"}[chunkId] + ".chunk.js";
};